angular
	.module 'App.Repository'
	.factory 'ProductVariantDataRepository', ['BaseRepository', (BaseRepository) ->
		class ProductVariantDataRepository extends BaseRepository
			@resource = '/product_variant_data'
			@isRestricted = true

		return new ProductVariantDataRepository
	]
